import { ThemeConstellation, FONT_TYPES } from '@zillow/constellation';

var ThemeCmsConstellation = Object.assign({}, ThemeConstellation, {
  constellation: Object.assign({}, ThemeConstellation.constellation, {
    colors: Object.assign({}, ThemeConstellation.constellation.colors, {
      backgroundBrand: ThemeConstellation.constellation.colors.blue400,
      textDarkBlue: ThemeConstellation.constellation.colors.blue600
    }),
    fontSizes: Object.assign({}, ThemeConstellation.constellation.fontSizes, {
      large: ThemeConstellation.constellation.fontSizes[FONT_TYPES.h5]
    }),
    fontWeights: Object.assign({}, ThemeConstellation.constellation.fontWeights, {
      large: ThemeConstellation.constellation.fontWeights[FONT_TYPES.body]
    }),
    lineHeights: Object.assign({}, ThemeConstellation.constellation.lineHeights, {
      large: ThemeConstellation.constellation.lineHeights[FONT_TYPES.h5]
    }),
    spacing: Object.assign({}, ThemeConstellation.constellation.spacing, {
      xxl: 64
    }),
    radii: Object.assign({}, ThemeConstellation.constellation.radii, {
      xl: 16,
      xxl: 24
    })
  })
});
var ThemeCmsConstellation$1 = ThemeCmsConstellation;

export { ThemeCmsConstellation$1 as default };
